<template>
  <div class="meta-tag-item columns" v-if="!deleted">
    <div class="centered column delete-column">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDelete"/>
    </div>
    <div class="column">
      <b-input
      v-model="metaTag.url"
      placeholder="url"
      :disabled="!editMode" />
    </div>
    <div class="column">
      <b-input
      v-model="metaTag.title"
      placeholder="Title"
      :disabled="!editMode" />
      <b-input
      v-model="metaTag.description"
      placeholder="Description"
      :disabled="!editMode" />
      <b-input
      v-model="metaTag.keywords"
      placeholder="Keywords"
      :disabled="!editMode" />
    </div>
    <div class="centered column edit edit-column">
      <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEdit" v-if="!editMode"/>
      <a class="button is-info" v-else @click="handleUpdateMetaTag">Сохранить</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'MetaTagItem',
  data () {
    return {
      editMode: false,
      deleted: false
    }
  },
  created () {
    if (this.metaTag.isNew) {
      this.editMode = true
    }
  },
  props: {
    metaTag: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteMetaTag', 'addMetaTag', 'updateMetaTag']),
    toggleEdit () {
      this.editMode = !this.editMode
    },
    handleDelete () {
      if (!this.metaTag.isNew) {
        this.deleteMetaTag(this.metaTag.id)
      }
      this.deleted = true
    },
    handleUpdateMetaTag () {
      if (this.metaTag.isNew) {
        this.addMetaTag(this.metaTag)
      } else {
        this.updateMetaTag(this.metaTag)
      }

      this.toggleEdit()
    }
  }
}
</script>

<style scoped>
.meta-tag-item {
  background: #eee;
  margin: 5px 0;
  padding: 10px;
  border-radius: 5px;
}
.delete-icon {
  position: initial;
}
img {
  height: 32px;
  width: 32px;
  margin: 0 8px;
  vertical-align: text-top;
}
.column {
  padding: 0;
}
.edit-icon {
  cursor: pointer;
  float: right;
}
.delete-column {
  max-width: 60px;
}
.edit-column {
    max-width: 110px;
}
.link {
  text-align: left;
  display: inline-block;
}
.control {
  margin-right: 15px;
}
.apply-icon {
  background: #006DF0;
  border-radius: 25px;
  padding: 5px;
  cursor: pointer;
}
form {
  margin: 0 15px 0 0;
}
</style>
<style>
.meta-tag-item input:disabled,
.is-disabled input{
  background: #eee !important;
  border: none !important;
  color: #000 !important;
}
.is-disabled .el-icon-caret-top {
  display: none;
}
.meta-tag-item .error input {
  border-color: red !important;
}
</style>



// WEBPACK FOOTER //
// MetaTagItem.vue?20e8508e